module.exports = __webpack_public_path__ + "007ab8f23810140df3164b579397d78b.ttf";